    <div class="row">

        <div class="column left" >   

            <ng-container>
                <ng-container *ngFor="let sectionComponents of ( sectionComponentRows | async )" class="row">
                    <ng-container *ngFor="let sectionComponent of sectionComponents" >                                                                     
                        <ds-themed-search-section *ngIf="sectionComponent.componentType === 'search'"                                                         
                                                [sectionId]="sectionId"     
                                                [searchSection]="$any(sectionComponent)">
                        </ds-themed-search-section>                                                                                                              
                    </ng-container>
                </ng-container>                                                
            </ng-container>
                    
            
           <!--<p style="padding-left: 200px; margin-top: 0px;">
                <a  routerLink="/explore/researchoutputs" style="font-size: large; padding-bottom: 1opx; margin-bottom: 10px; "><strong>Publication Advanced Search</strong> </a>                
            </p>-->  
      
            
            <div style="margin-top: 30px;">
                <ng-container> 
                    <div><ds-themed-home-news></ds-themed-home-news></div>                                                          
                </ng-container>
            </div>
           
        </div>  <!-- Column Left -->


        <!--
        <div class="column left" style="background-image: url('assets/images/banner.png');  position: relative;">
            <br/>
            <ng-container *ngFor="let sectionComponents of ( sectionComponentRows | async )">
                <ng-container *ngFor="let sectionComponent of sectionComponents" >                        
                    <div>
                        <ds-themed-search-section *ngIf="sectionComponent.componentType === 'search'"                                                       
                            [sectionId]="sectionId"     
                            [searchSection]="$any(sectionComponent)">
                        </ds-themed-search-section>                                                                            
                    </div>
                </ng-container>                                                          
            </ng-container>                                      
                    
            <div class="d-flex flex-wrap justify-content-start ml-auto" >
                <p style="text-align:left; padding-left:50px; padding-right: 30px;"><b>Universiti Malaysia Perlis Research Repository</b></p>
                <p style="text-align:left; padding-left:50px; padding-right: 30px;"> provides platform for UniMAP open access publication, research data and research expertise. </p>                          
            </div>      
              
            <div >
                <ul style="list-style: none;">  
                    <li><img src="assets/images/openaccess.png"> Open Access Publication</li>
                    <li><img src="assets/images/hi-impact.png"> High-impact publications</li>
                    <li><img src="assets/images/research data.png"> Research Data / Open Data</li>
                    <li><img src="assets/images/researcher1.png"> Researcher</li>        
                    <li><img src="assets/images/ris.png"> Research Information System</li>
                </ul>    
            </div>                                                               
        </div> -->   <!-- Column Left -->
             
                 
        <div class="column right" >   

            <!-- <div>
                <ng-container *ngFor="let sectionComponents of ( sectionComponentRows | async )" class="row">
                    <ng-container *ngFor="let sectionComponent of sectionComponents">      
                        <div>                              
                            <ds-themed-facet-section *ngIf="sectionComponent.componentType === 'facet'"
                                [sectionId]="sectionId"
                                [facetSection]="$any(sectionComponent)">
                            </ds-themed-facet-section>

                            <ds-themed-counters-section *ngIf="sectionComponent.componentType === 'counters'"
                                [sectionId]="sectionId"
                                [countersSection]="$any(sectionComponent)">
                            </ds-themed-counters-section>
                        </div>
                    </ng-container>                              
                </ng-container>   
            </div> -->            
            <!-- <hr style="border-top: 3px solid #0f0e0e;">                     
            <hr>--> 

            

            <div class="tab">               
                <button class="tablinks" (click)="callFunction1('RecentSubmissions')" #initload>Recent Submissions</button>
                <button class="tablinks" (click)="callFunction1('MostViewed')">Most Viewed</button>
                <!-- <button class="tablinks" (click)="callFunction1('MostCited')">Scopus Most Cited</button>-->
                <!--<button class="tablinks" (click)="callFunction1('MostDownloaded')">Most Downloaded</button>-->
                <button class="tablinks" (click)="callFunction1('StatusCount')">Site Counters</button>     
            </div>

            <!--<div class="tab">
                <button class="tablinks" (click)="clickMainContent()">Recent Submissions</button>
                <button (click)="clickSubContent()" #subcontent>Change sub content</button>
            </div>-->
            <!--<div class="tab">
                <button class="tablinks" onclick="openSelection(event, 'RecentSubmissions')" id="defaultOpen">Recent Submissions</button>       
                <button class="tablinks" onclick="openSelection(event, 'MostViewed')">Most Viewed</button>       
                <button class="tablinks" onclick="openSelection(event, 'MostCited')">Scopus Most Cited</button>       
                <button class="tablinks" onclick="openSelection(event, 'MostDownload')">Most Download</button>      
                <button class="tablinks" onclick="openSelection(event, 'StatusCount')">Site Counters</button>           
            </div>-->   

            <!-- Tab content -->
            <div id="RecentSubmissions" class="tabcontent">
                <ng-container *ngFor="let sectionComponents of ( sectionComponentRows | async )" class="row">
                    <ng-container *ngFor="let sectionComponent of sectionComponents">        
                        <div>
                            <ds-themed-top-section *ngIf="sectionComponent.componentType === 'top' && 
                                                            sectionComponent?.sortField === 'dc.date.accessioned'"                                                         
                                [sectionId]="sectionId"     
                                [topSection]="$any(sectionComponent)"> 
                            </ds-themed-top-section>                        
                        </div>
                    </ng-container>                              
                </ng-container>
            </div>

            <div id="MostViewed" class="tabcontent">
                <ng-container *ngFor="let sectionComponents of ( sectionComponentRows | async )" class="row">
                    <ng-container *ngFor="let sectionComponent of sectionComponents">        
                        <div>    
                            <ds-themed-top-section *ngIf="sectionComponent.componentType === 'top' && 
                                                          sectionComponent?.sortField  === 'metric.view'"                                                       
                                    [sectionId]="sectionId"                                     
                                    [topSection]="$any(sectionComponent)"> 
                                    
                            </ds-themed-top-section>                                                    
                        </div>
                    </ng-container>                              
                </ng-container>
            </div>
        


            <div id="MostDownloaded" class="tabcontent">
                <ng-container *ngFor="let sectionComponents of ( sectionComponentRows | async )" class="row">
                    <ng-container *ngFor="let sectionComponent of sectionComponents">        
                        <div>                                
                            <ds-themed-top-section *ngIf="sectionComponent.componentType === 'top' && 
                                                 sectionComponent?.sortField === 'metric.download'"                                                         
                                    [sectionId]="sectionId"     
                                    [topSection]="$any(sectionComponent)">
                                   
                            </ds-themed-top-section>                                                    
                        </div>
                    </ng-container>                              
                </ng-container>
            </div>
            

            <div id="MostCited" class="tabcontent">
                <ng-container *ngFor="let sectionComponents of ( sectionComponentRows | async )" class="row">
                    <ng-container *ngFor="let sectionComponent of sectionComponents">        
                        <div>    
                                                   
                            <ds-themed-top-section *ngIf="sectionComponent.componentType === 'top' && 
                                                          sectionComponent?.scopus === 'metric.scopus.citation'"                                                         
                                [sectionId]="sectionId"     
                                [topSection]="sectionComponent"> 
                            </ds-themed-top-section>

                        </div>
                    </ng-container>                              
                </ng-container>
            </div>

  
            <div id="StatusCount" class="tabcontent">
                <ng-container *ngFor="let sectionComponents of ( sectionComponentRows | async )" class="row">
                    <ng-container *ngFor="let sectionComponent of sectionComponents">        
                        <div>    
                                                                                                        
                            <ds-themed-facet-section *ngIf="sectionComponent.componentType === 'facet'"
                                    [sectionId]="sectionId"
                                    [facetSection]="$any(sectionComponent)">
                            </ds-themed-facet-section>
            
                            <ds-themed-counters-section *ngIf="sectionComponent.componentType === 'counters'" 
                                            [sectionId]="sectionId"
                                            [countersSection]="$any(sectionComponent)">
                            </ds-themed-counters-section>
                                             
                        </div>
                    </ng-container>                              
                </ng-container>
            </div>




                         
        </div> <!-- Column right -->
    </div> <!-- Row -->
  
    <ds-suggestions-popup></ds-suggestions-popup>

